import { eraseCookie, setCookie, getCookie } from '../../../views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { get_request_params } from '../../properties/headers';
import { SomethingWentWrong, controller } from '../helpers';
import { failureToast } from 'views/pages/manage/common/utils/methods/toasterFunctions/function';
import { LOGOUTMESSAGE } from "../../constant"
import { isVersionBuildUpdated } from '..';

async function getAPI(url, _success, _failure, header = null, id = '') {
  try {
    const request_params = get_request_params('get', null, header, id);
    setCookie('lastKnowPath', document.URL.split('#')[1]);
    await fetch(url, request_params)
      .then(function (response) {
        isVersionBuildUpdated(response)
        if ((response.status === 403 || response.status === 401) && getCookie('token')) {
          failureToast(LOGOUTMESSAGE);
          eraseCookie('token');
          controller.abort();
          setTimeout(() => window.location.replace(`${document.URL.split('#')[0]}`), 3000);
          return null
        }
        if (response.ok) {
          return response.json();
        } else {
          response
            .json()
            .then(er => {
              _failure(er);
            })
            .catch(error => { });
        }
      })
      .then(function (data) {
        _success(data);
      })
      .catch(error => {
        console.log(error.message);
        // _failure(error);
      });
  } catch (e) {
    SomethingWentWrong();
    console.log('Error', e);
  }
}
async function getPDF(url, _success, _failure, header = null, id = '', fileName) {
  try {
    const request_params = get_request_params('get', null, header, id);
    setCookie('lastKnowPath', document.URL.split('#')[1]);
    await fetch(url, request_params)
      .then(function (response) {
        isVersionBuildUpdated(response)
        if ((response.status === 403 || response.status === 401) && getCookie('token')) {
          failureToast(LOGOUTMESSAGE);
          eraseCookie('token');
          controller.abort();
          setTimeout(() => window.location.replace(`${document.URL.split('#')[0]}`), 3000);
          return null
        }
        if (response.ok) {
          return response.blob().then((blob) => {
            return { blob, response }; // keep response to extract headers later
          });
        } else {
          response
            .json()
            .then(er => {
              _failure(er);
            })
            .catch(error => { });
        }
      })
      .then(function (data) {
        if (data && data?.blob instanceof Blob) {
          // Handle PDF Blob
          const { blob, response } = data;
          let disposition = response.headers.get("content-disposition");
          let extractedFileName = null;

          if (disposition) {
            // Match filename= inside the header
            const fileNameMatch = disposition.match(/filename\*?=(?:UTF-8''|")?([^\";]+)/i);
            if (fileNameMatch && fileNameMatch.length > 1) {
              extractedFileName = decodeURIComponent(fileNameMatch[1].trim());
            }
          }
          // Final file name (priority: header > passed > fallback)
          const finalFileName =
            extractedFileName || (fileName ? `${fileName}.pdf` : 'file.pdf');
          const downloadLink = document.createElement('a');
          const url = URL.createObjectURL(blob);
          downloadLink.href = url;
          downloadLink.download = finalFileName // Set desired filename
          downloadLink.click();
          URL.revokeObjectURL(url); // Clean up the URL
          _success('PDF downloaded successfully');
        } else {
          // Handle JSON data
          _success(data);
        }
      })
      .catch(error => {
        console.error('Fetch error:', error.message);
        _failure(error);
      });
  } catch (e) {
    SomethingWentWrong();
    console.error('Error:', e);
  }
}

async function getAPIv2(url, _success, _failure, header = null, id = '') {
  try {
    const request_params = get_request_params('get', null, header, id);
    setCookie('lastKnowPath', document.URL.split('#')[1]);

    const response = await fetch(url, request_params);
    isVersionBuildUpdated(response);

    if ((response.status === 403 || response.status === 401) && getCookie('token')) {
      failureToast(LOGOUTMESSAGE);
      eraseCookie('token');
      controller.abort();
      setTimeout(() => window.location.replace(`${document.URL.split('#')[0]}`), 3000);
      return;
    }

    if (response.ok) {
      const data = await response.json();
      const state = response.headers.get('State'); // Extract the desired header state
      _success({ data, state }); // Pass data and state to _success
    } else {
      const errorData = await response.json();
      _failure(errorData);
    }
  } catch (error) {
    SomethingWentWrong();
    console.log('Error', error);
    // Optionally handle the failure callback here
    // _failure(error);
  }
}

export { getAPI, getAPIv2, getPDF };
